import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { isOwnBackend } from './backend';
import { LoginService } from './login.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private loginSerivce: LoginService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Fremde Adressen bekommen weder Schlüssel noch Token.
    if (!isOwnBackend(request.url)) {
      return next.handle(request);
    }

    // Pro Aufruf gelesen: nach einer Erneuerung geht sofort das neue Token mit.
    const token = this.loginSerivce.getJWTToken(); // string | null

    // Immer auf request.headers aufbauen, nie new HttpHeaders().
    let headers = request.headers
      .set('x-apikey', environment.apiKey)
      .set('x-ts', tsUtcString(Date.now()));

    // Nur wenn ein Token vorhanden ist, sonst ginge "Bearer " leer hinaus.
    if (token) {
      // Einziger Header, aus dem das Backend den JWT liest (JwtValidator).
      headers = headers.set('Authorization', `Bearer ${token}`);
      // Altlast, nur noch fürs Prüfprotokoll.
      headers = headers.set('Token', token);
    }

    return next.handle(request.clone({ headers }));
  }
}

/** `yyyyMMddHHmmssSSS` in UTC, Format des Backends (wird nicht erzwungen). */
function tsUtcString(ms: number): string {
  const d = new Date(ms);
  const pad = (v: number, len = 2) => String(v).padStart(len, '0');
  return (
    String(d.getUTCFullYear()) +
    pad(d.getUTCMonth() + 1) +
    pad(d.getUTCDate()) +
    pad(d.getUTCHours()) +
    pad(d.getUTCMinutes()) +
    pad(d.getUTCSeconds()) +
    pad(d.getUTCMilliseconds(), 3)
  );
}
